"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var search_exports = {};
__export(search_exports, {
  containsSearch: () => containsSearch,
  normalizeSearch: () => normalizeSearch,
  searchLiteralPattern: () => searchLiteralPattern
});
module.exports = __toCommonJS(search_exports);
function normalizeSearch(value) {
  return value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}
__name(normalizeSearch, "normalizeSearch");
function containsSearch(value, query) {
  return typeof value === "string" && normalizeSearch(value).includes(normalizeSearch(query));
}
__name(containsSearch, "containsSearch");
let variants;
function searchLiteralPattern(query) {
  if (variants === void 0) {
    variants = /* @__PURE__ */ new Map();
    for (let point = 0; point <= 12287; point++) {
      const char = String.fromCodePoint(point);
      const folded = normalizeSearch(char);
      if (folded.length !== 1 || char === folded || /\p{M}/u.test(char)) continue;
      const set = variants.get(folded) ?? /* @__PURE__ */ new Set();
      set.add(char);
      variants.set(folded, set);
    }
  }
  const escape = /* @__PURE__ */ __name((text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "escape");
  return [...normalizeSearch(query)].map((char) => {
    const chars = variants?.get(char);
    const literal = chars === void 0 ? escape(char) : `(?:${[char, ...chars].map(escape).join("|")})`;
    return literal + "\\p{M}*";
  }).join("");
}
__name(searchLiteralPattern, "searchLiteralPattern");
//# sourceMappingURL=search.js.map
